import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: 'form[appEnterSubmit]',
  standalone: true
})
export class EnterSubmitDirective {
  private readonly elementRef = inject<ElementRef<HTMLFormElement>>(ElementRef);

  @HostListener('keydown.enter', ['$event'])
  submitOnEnter(event: KeyboardEvent): void {
    if (event.defaultPrevented || event.isComposing) {
      return;
    }

    const target = event.target instanceof HTMLElement ? event.target : null;
    if (
      !target ||
      target instanceof HTMLTextAreaElement ||
      target.isContentEditable ||
      target.closest('button, mat-select, .mat-mdc-select') ||
      target.getAttribute('aria-expanded') === 'true'
    ) {
      return;
    }

    const submitButton = this.elementRef.nativeElement.querySelector<HTMLButtonElement>(
      'button[type="submit"]:not([disabled])'
    );
    if (!submitButton) {
      return;
    }

    event.preventDefault();
    this.elementRef.nativeElement.requestSubmit(submitButton);
  }
}
